import { render, staticRenderFns } from "./ChangePass.vue?vue&type=template&id=77093944&scoped=true&"
import script from "./ChangePass.vue?vue&type=script&lang=js&"
export * from "./ChangePass.vue?vue&type=script&lang=js&"
import style0 from "./ChangePass.vue?vue&type=style&index=0&id=77093944&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77093944",
  null
  
)

export default component.exports